//  Google Tag Manager
(function(w, d, s, l, i) {
    if (!location.hostname.match(/timeperformance\.com/i)) return;

    w[l] = w[l] || [];
    w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0],
    /** @type {HTMLScriptElement} */  j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-58CRMVT');

// détecte l'origine Adwords de la visite
(function(w) {
    // enregistrement gclid
    function setCookie(name, value, days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toUTCString();
        expires += "; domain=timeperformance.com";
        document.cookie = name + "=" + value + expires;
    }

    const queryParams = new URLSearchParams(window.location.search);
    var gclid = queryParams.get('gclid');
    if (gclid) {
        var gclsrc = queryParams.get('gclsrc');
        if (!gclsrc || gclsrc.indexOf('aw') !== -1) {
            setCookie('gclid', gclid, 90);
        }
    }
})(window);